import { render, staticRenderFns } from "./QualRewardGroupPanel.vue?vue&type=template&id=242d87cd"
import script from "./QualRewardGroupPanel.vue?vue&type=script&lang=ts"
export * from "./QualRewardGroupPanel.vue?vue&type=script&lang=ts"
import style0 from "./QualRewardGroupPanel.vue?vue&type=style&index=0&id=242d87cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports